import { SkillType } from '../enums';

export interface UserSkillModel {
  id: string;
  skill_id: string | null;
  skill_name: string | null;
  skill_mapping_name: string | null;
  rating: number | null;
  rating_written: number | null;
  is_native: boolean | null;
  type: SkillType;
  order: number;
}

export interface EditUserSkillListModel {
  type?: SkillType;
  items: UserSkillModel[] | null;
}
